import React from "react";
import { RootSiblingParent } from "react-native-root-siblings";
import AppLoading from 'expo-app-loading';
import { useFonts, Roboto_300Light, Roboto_400Regular, Roboto_700Bold, Roboto_500Medium } from '@expo-google-fonts/roboto';

import Routes from "./src/routes";

export default function App() {
  let [fontsLoaded] = useFonts({
    Roboto_300Light, Roboto_400Regular, Roboto_700Bold, Roboto_500Medium
  });

  if (!fontsLoaded) {
    return <AppLoading />;
  } else {
    return (
      <RootSiblingParent>
        <Routes />
      </RootSiblingParent>
    );
  }
}
